import $ from 'jquery';
window.$ = window.jQuery = $;
import AOS from 'aos';
import gsap from 'gsap';
import "jquery-match-height/jquery.matchHeight";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import Lenis from '@studio-freight/lenis'
gsap.registerPlugin(ScrollTrigger);

import "@fortawesome/fontawesome-free/js/fontawesome.min";
import "@fortawesome/fontawesome-free/js/solid.min";
import "@fortawesome/fontawesome-free/js/regular.min";
import "@fortawesome/fontawesome-free/js/brands.min";


import Swiper, { Navigation, Pagination } from 'swiper';
// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);
// import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import 'select2';
import 'select2/dist/css/select2.min.css';

import 'slick-slider';

//App imports

import {menuMain} from "./menu";
import {miniCart} from "./miniCart";
import {customAddToCart} from "./customAddToCart";
import {productCustomiser} from "./productCustomiserNew";

/****************************************************************************
 * Theme scripts.
 ****************************************************************************/


window.addEventListener('load', function() {
    AOS.refresh();
});

$(document).on('facetwp-loaded', function() {
    console.log(FWP.settings.num_choices)
    $.each(FWP.settings.num_choices, function(key, val) {

        var $parent = $('.facetwp-facet-' + key).parent()
        if(val == 0){
            $parent.hide();
        }else{
            $parent.show();
        }

    });
});



(function( $ ){
    'use strict';

    setTimeout( () => {
        AOS.init({  duration: 1000 });

        var swiper = new Swiper('.slider', {
            slidesPerView: 1,
            freeMode: true,
            autoHeight: true,
            pagination: {
                el: '.slider-pagination',
                clickable: true,
            },
        });
        var thumbsSwiper = new Swiper('.product-slider-thumbs',{
            slidesPerView: 4,
            loop: false,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            watchOverflow: true,
            freeMode: false,
            breakpoints: {

                // when window width is >= 640px
                768: {
                    direction: 'vertical'
                }
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        });
        var swiperGallery = new Swiper('.product-slider', {
            slidesPerView: 1,
            spaceBetween: 30,
            freeMode: true,
            loop: false,
            thumbs: {
                swiper: thumbsSwiper
            }
        });

        swiperGallery.on("slideChangeTransitionStart", function () {
            thumbsSwiper.slideTo(swiperGallery.activeIndex);
        });
        thumbsSwiper.on("transitionStart", function () {
            swiperGallery.slideTo(thumbsSwiper.activeIndex);
        });

        thumbsSwiper.on("click", function () {
            swiperGallery.slideTo(thumbsSwiper.activeIndex);
        });

        $('.slider-init').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: false,
            nextArrow: false,
            dots: true,
            adaptiveHeight: true
        });

        $('.sitewide-notice .d-flex').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: false,
            nextArrow: false,
            dots: false,
            adaptiveHeight: false,
            autoplay: true,
            autoplaySpeed: 3000,
            infinite: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                }
            ]
        });

        $('.related .products').slick({
            slidesToShow: 1.5,
            slidesToScroll: 1,
            mobileFirst: true,
            dots: false,
            prevArrow: false,
            nextArrow: false,
            centerMode: false,
            infinite: false,
            responsive: [
                {
                    breakpoint: 540,
                    settings: 'unslick'
                }
            ]
        });

        $('.block-grid-module__product .products').slick({
            slidesToShow: 1.5,
            slidesToScroll: 1,
            mobileFirst: true,
            dots: false,
            prevArrow: false,
            nextArrow: false,
            centerMode: false,
            infinite: false,
            responsive: [
                {
                    breakpoint: 540,
                    settings: 'unslick'
                }
            ]
        });

        $('.js-cancel, .js-view').on('click', function(){
            $('#main-sidebar').removeClass('active');
        });


        $('.swatch-single-wrapper .swatches .swatch').on('click', function(){
            var slideno = $(this).attr('data-id');
            $('.swatch').removeClass('active');
            $(this).addClass('active');
            $('.slider-nav').slick('slickGoTo', slideno);
        })


        $('.slider-for').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.slider-nav',
            infinite: false,
        });
        $('.slider-nav').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            vertical:true,
            asNavFor: '.slider-for',
            dots: false,
            infinite: false,
            focusOnSelect: true,
            verticalSwiping:true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        vertical: false,
                        arrows: false,
                        rows:0,
                        adaptiveHeight: true,
                    }
                },
            ]
        });


        $("#single").select2({
            allowClear: false
        });

        var totalRows = $('.js-rows').length;
        var clicks = 0;
        $('.js-add-colours').on('click', function(){
            console.log(clicks + '/' + totalRows);
            $('[data-row="'+ clicks +'"]').addClass('active');
            console.log($('.js-rows:visible').length);

            if(clicks == totalRows - 1){
                $(this).hide();
            }

            clicks++;
        })

        function formatState(state) {
            const option = $(state.element);
            const color = option.data("colour");

            if (!color) {
                return state.text;
            }

            return $(`<span class="swatch-select" data-colour="${color}"><span></span>${state.text}</span>`);
        }


        $('.js-select-colour').each(function(index, el){

            $(el).select2({
                allowClear: false,
                templateResult: formatState,
                templateSelection: formatState,
            });

            $(el).on('select2:select', function (e) {
                $(this).parent().parent().find('input').val('');
            });

        })

        // $('form input').keypress(function(e){
        //     if ( e.which == 13 ) return false;
        // });
// (function($) {
//     "use strict";
//
//     // The WooCommerceAutocomplete object.
//     var WooCommerceAutocomplete = {
//
//         // The products array.
//         products: [],
//
//         // The search input element.
//         searchInput: null,
//
//         // The autocomplete results list.
//         resultsList: null,
//
//         // The autocomplete results template.
//         resultsTemplate: '<li><a href="{{product_url}}">{{product_name}}</a></li>',
//
//         // The autocomplete options.
//         options: {
//             minLength: 3
//         },
//
//         // The autocomplete event handler.
//         autocompleteHandler: function(event) {
//             // Prevent the default action.
//             event.preventDefault();
//
//             // Clear the results list.
//             this.resultsList.html('');
//
//             // Get the search term.
//             var searchTerm = this.searchInput.val();
//
//             // If the search term is empty, return.
//             if (searchTerm === '') {
//                 return;
//             }
//
//             // Get the matching products.
//             var matchingProducts = this.products.filter(function(product) {
//                 return product.name.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;
//             });
//
//             // Loop through the matching products and add them to the results list.
//             matchingProducts.forEach(function(product) {
//                 var result = $(this.resultsTemplate).html(product.name).data('product', product);
//                 this.resultsList.append(result);
//             }, this);
//         },
//
//         // Initialize the autocomplete.
//         init: function() {
//             // Get the search input element.
//             this.searchInput = $('.search-field');
//
//             console.log(this.searchInput = $('.search-field'));
//
//             // Get the autocomplete results list.
//             this.resultsList = $('#product_search_results');
//
//             // Bind the autocomplete event handler to the search input element.
//             this.searchInput.on('input', this.autocompleteHandler);
//         }
//     };
//
//     // Initialize the autocomplete.
//     WooCommerceAutocomplete.init();
// })(jQuery);

// Define the html variable.

// Define the html variable.
        var html = '';
        var ajaxurl = window.ajaxurl;
// Bind an event handler to the search input element.

        // document.addEventListener('facetwp-loaded', function() {
        //     fUtil('.woocommerce-ordering select').fSelect({showSearch: false});
        // });

        $('body').on('click', '.facet-wrap h3', function(){
            $(this).parent().find('.facetwp-facet').slideToggle();
            $(this).toggleClass('active');
        })

        $('.clear-filters').on('click',function(){
            $('#facetlist').empty();
        })

        var listArray = [];

        $('body').on('click', '.facetwp-display-value', function(){
            let facet_dataname = $(this).text();

            if(!listArray.includes(facet_dataname)){
                listArray.push(facet_dataname);
                $('#facetlist').empty();
                var listArrayLength = listArray.length;
                for (var i = 0; i < listArrayLength; i++) {
                    console.log(listArray[i]);
                    $('#facetlist').append('<li>'+ listArray[i] +'</li>');
                    //Do something
                }


                //$('#facetlist').append('<li>'+ facet_dataname +'</li>');
            }else{
                $('#facetlist').empty();
                for (var i=listArray.length-1; i>=0; i--) {
                    if (listArray[i] === facet_dataname) {
                        listArray.splice(i, 1);
                    }
                }

                var listArrayLength = listArray.length;
                for (var i = 0; i < listArrayLength; i++) {
                    console.log(listArray[i]);
                    $('#facetlist').append('<li>'+ listArray[i] +'</li>');
                    //Do something
                }

            }
            $('.you-have-selected').slideDown();
            console.log(listArray);
        })

        $('.menu-bars').on('click', function(){
            $('body').toggleClass('menu-active');
            $('.mini-cart__menu').hide();
        })

        $('body').on('click','[data-name="product_colour"]', function(e){
            var $value = $(this).find('[data-value]').attr('data-value');


            var $variations = $('body').find('[data-variation="'+ $value +'"]');

            setTimeout(function(){
                $.each($variations, function(index, el){
                    // $('[data-variation]').hide();
                    // $(el).show();
                    // $(el).parent().find('.size-woocommerce_thumbnail').hide();
                })
            }, 3000)

            // if($variation.length > 0){
            //     $variation.show();
            // }


        })


        function getUrlVars()
        {
            var vars = [], hash;
            var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
            for(var i = 0; i < hashes.length; i++)
            {
                hash = hashes[i].split('=');
                vars.push(hash[0]);
                vars[hash[0]] = hash[1];
            }
            return vars;
        }

        // $("form .orderby").select2({
        //     allowClear: false
        // });

        $('.js-show-categories').on('click', function(){
            $('#main-sidebar').addClass('active');
        })


        $('b[role="presentation"]').hide();
        $('.select2-selection__arrow').append('<i class="fa fa-angle-down"></i>');

        menuMain.init();
        miniCart.init();
        customAddToCart.init();
        productCustomiser.init();

        //Swatch popup

        $('.swatch-count').on('click', function(e){
            // $('.swatch-popup').removeClass('active');
            // if($(this).parent().find('.swatch-popup').hasClass('active')){
            //
            // }
            $(this).parent().find('.swatch-popup').toggleClass('active');
        })

        //Details

        $('[data-accordion]').on('click', function(){
            $(this).toggleClass('active');
            $('.accordion__content').slideToggle();
        })

        $('.page-numbers a').on('click', function(){
            $('.page-numbers span').removeClass('current');
            $(this).addClass('current');
        })



        // const lenis = new Lenis({
        //     duration: 1.2,
        //     easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
        //     direction: 'vertical', // vertical, horizontal
        //     gestureDirection: 'vertical', // vertical, horizontal, both
        //     smooth: true,
        //     mouseMultiplier: 0.5,
        //     smoothTouch: false,
        //     touchMultiplier: 2,
        //     infinite: false,
        // });
        //
        // function raf(time) {
        //     lenis.raf(time)
        //     requestAnimationFrame(raf)
        // }
        //
        // requestAnimationFrame(raf);


    }, 400 );

    setTimeout( () => {

        // scroll.update();

    }, 2000 );

    $(window).on('scroll', function (event) {
        AOS.refresh();
    });


} )( jQuery );

$(function(){



})

/***************
 * After theme scripts
 ***************/
// // Each time the window updates, refresh ScrollTrigger and then update LocomotiveScroll
// ScrollTrigger.addEventListener( 'refresh', () => scroll.update() );
//
// // After everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
// ScrollTrigger.refresh();